/* eslint-disable */

/**
 * 判断是否是latino渠道发起的请求
 * @param ctx
 * @returns
 */
export function isLatinoChannel(ctx?: any) {
  const channel: string = 'latino';
  return channel === 'latino';
}

export function isMainChannel(ctx?: any) {
  const channel: string = 'latino';
  return channel === 'weee';
}
